export default __webpack_public_path__ + "static/media/index.e2b6f656.less";